<template>
    <div class="garant-part">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-10">
                    <div class="garant-list">


                        <div class="garant_item">
                            <img src="../../../../img/header/shield.svg" alt="">
                            <p class="min">Elbyte med prisgaranti</p>
                        </div>
                        <div class="garant_item">
                            <img src="../../../../img/header/scales.svg" alt="">
                            <p class="min">Jämför och byt gratis</p>
                        </div>
                        <div class="garant_item">
                            <img src="../../../../img/header/calendar.svg" alt="">
                            <p class="min">14 dagars ångerrätt</p>
                        </div>
                        <div class="garant_item big-item">
                            <img src="../../../../img/candel.svg" alt="">
                            <p class="min">A switch never causes any power failure</p>
                        </div>
                        <div class="garant_item big-item">
                            <img src="../../../../img/cash2.svg" alt="">
                            <p class="min">In average our customers save 2000 Kr/year</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GarantSect"
    }
</script>
